import { GoogleBulkState } from './model';
import { createReducer } from '@reduxjs/toolkit';
import * as googleBulkActions from './actions';

const initial: GoogleBulkState = {
  inProgress: {},
  progressValues: {},
  links: {},
};

export const googleBulkReducer = createReducer<GoogleBulkState>(initial, (builder) =>
  builder
    .addCase(googleBulkActions.linkCreated, (s, a) => {
      s.links[a.payload.hash] = a.payload.link;
    })
    .addCase(googleBulkActions.setInProgress, (s, a) => {
      if (a.payload.inProgress) {
        s.inProgress[a.payload.hash] = a.payload.inProgress;
      } else {
        delete s.inProgress[a.payload.hash];
        delete s.progressValues[a.payload.hash];
      }
    })
    .addCase(googleBulkActions.setProgressValue, (s, a) => {
      s.progressValues[a.payload.hash] = a.payload.value;
    }),
);
